import { computed } from '@ember/object';
export default function contains(property, value) {
  return computed(`${property}.[]`, function () {
    const prop = this.get(property);
    return (prop === undefined ? [] : prop).includes(value);
  });
}